import { userClient } from '@/js/helpers/backend-clients';
import router from '@/router';
import {
  displayAxiosError,
  displayInfoMessage,
  hideLoadingOverlay,
  showLoadingOverlay,
} from '@/js/helpers/utils';

const defaultState = () => {
  return {
    loading: undefined,
    userMessage: {
      message: '',
      type: '',
    },
    user: {
      emailAdresse: '',
      name1: '',
      name2: '',
      plz: '',
      ort: '',
      str: '',
      hnr: '',
      passwort: '',
      passwortBestaetigung: '',
      nutzungsbedingungenZugestimmt: false,
      userReferer: 'Sprengnetter',
    },
  };
};

const state = defaultState();

const mutations = {
  UPDATE_USER_MESSAGE(state, userMessage) {
    state.userMessage = userMessage;
  },

  UPDATE_EMAIL_ADRESSE(state, emailAdresse) {
    state.user.emailAdresse = emailAdresse;
  },

  UPDATE_NAME1(state, value) {
    state.user.name1 = value;
  },

  UPDATE_NAME2(state, value) {
    state.user.name2 = value;
  },

  UPDATE_PLZ(state, value) {
    state.user.plz = value;
  },

  UPDATE_ORT(state, value) {
    state.user.ort = value;
  },

  UPDATE_STR(state, value) {
    state.user.str = value;
  },

  UPDATE_HNR(state, value) {
    state.user.hnr = value;
  },

  UPDATE_PASSWORT(state, passwort) {
    state.user.passwort = passwort;
  },

  UPDATE_PASSWORT_BEST(state, passwort) {
    state.user.passwortBestaetigung = passwort;
  },

  UPDATE_NUTZUNGSBEDINGUNGEN_ZUGESTIMMT(state, nutzungsbedingungenZugestimmt) {
    state.user.nutzungsbedingungenZugestimmt = nutzungsbedingungenZugestimmt;
  },

  UPDATE_USER_REFERER(state, userReferer) {
    state.user.userReferer = userReferer;
  },

  RESET_STATE(state) {
    Object.assign(state, defaultState());
  },
};

const actions = {
  clearUserMessage({ commit }) {
    commit('UPDATE_USER_MESSAGE', undefined);
  },

  updateEmailAdresse({ commit }, emailAdresse) {
    commit('UPDATE_EMAIL_ADRESSE', emailAdresse);
  },

  updateName1({ commit }, value) {
    commit('UPDATE_NAME1', value);
  },

  updateName2({ commit }, value) {
    commit('UPDATE_NAME2', value);
  },

  updatePlz({ commit }, value) {
    commit('UPDATE_PLZ', value);
  },

  updateOrt({ commit }, value) {
    commit('UPDATE_ORT', value);
  },

  updateStr({ commit }, value) {
    commit('UPDATE_STR', value);
  },

  updateHnr({ commit }, value) {
    commit('UPDATE_HNR', value);
  },

  updatePasswort({ commit }, passwort) {
    commit('UPDATE_PASSWORT', passwort);
  },

  updatePasswortBestaetigung({ commit }, passwort) {
    commit('UPDATE_PASSWORT_BEST', passwort);
  },

  updateNutzungsbedingungenZugestimmt({ commit }, nutzungsbedingungenZugestimmt) {
    commit('UPDATE_NUTZUNGSBEDINGUNGEN_ZUGESTIMMT', nutzungsbedingungenZugestimmt);
  },

  updateUserReferer({ commit }, userReferer) {
    commit('UPDATE_USER_REFERER', userReferer);
  },

  registriereUser({ dispatch, commit }) {
    showLoadingOverlay();
    userClient
      .registriere(state.user)
      .then(response => {
        if (response.status === 204) {
          // Benutzer direkt einloggen
          dispatch(
            'user/login',
            {
              username: state.user.emailAdresse,
              password: state.user.passwort,
            },
            { root: true },
          );
          commit('RESET_STATE');
        }
      })
      .catch(error => {
        if (error.response.status === 409) {
          router.push('/login');
          displayInfoMessage(
            `Der Benutzer ${state.user.emailAdresse} existiert bereits. Sie werden zum Login weitergeleitet.`,
          );
        } else {
          displayAxiosError(error);
        }
      })
      .finally(() => {
        hideLoadingOverlay();
      });
  },
};

const getters = {
  userMessage: () => {
    return state.userMessage;
  },

  user: () => {
    return state.user;
  },
};

const registrierungModule = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default registrierungModule;
